import { MapUtils } from '../../utility/map-utils.js';
import { cloneListOfCloneable, isSameData, isSameList } from '../dto/data-model-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';
import { ArtistProfile } from './artist-profile.js';
import { BrandProfile } from './brand-profile.js';
import { OrganizerProfile } from './organizer-profile.js';

export class EventAssociations extends DataModel {
  static readonly TYPE_ID: string = '4f1faebd6aff4ba3b8a2be425d236f9c';

  private constructor(
    public readonly artists: ArtistProfile[],
    public readonly brands: BrandProfile[],
    public readonly organizers: OrganizerProfile[],
  ) {
    super();
  }

  static create(args: {
    artists: ArtistProfile[],
    brands: BrandProfile[],
    organizers: OrganizerProfile[],
  }): EventAssociations {
    return new EventAssociations(
        args.artists,
        args.brands,
        args.organizers,
    );
  }

  get $typeId(): string {
    return EventAssociations.TYPE_ID;
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): EventAssociations {
    return new EventAssociations(
      MapUtils.getList<ArtistProfile>(map, 'artists', (value) => {
        return context.fromData<ArtistProfile>(value as SerializedData);
      }),
      MapUtils.getList<BrandProfile>(map, 'brands', (value) => {
        return context.fromData<BrandProfile>(value as SerializedData);
      }),
      MapUtils.getList<OrganizerProfile>(map, 'organizers', (value) => {
        return context.fromData<OrganizerProfile>(value as SerializedData);
      }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      artists: this.artists.map((e) => context.toData(e)),
      brands: this.brands.map((e) => context.toData(e)),
      organizers: this.organizers.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return new EventAssociations(
        cloneListOfCloneable(this.artists),
        cloneListOfCloneable(this.brands),
        cloneListOfCloneable(this.organizers),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.artists, this.artists, isSameData) &&
        isSameList(other.brands, this.brands, isSameData) &&
        isSameList(other.organizers, this.organizers, isSameData);
  }
}

export class EventAssociationsBuilder extends DataModelBuilder<EventAssociations> {
  build(context: SerializationContext, map: SerializedData): EventAssociations {
    return EventAssociations.fromMap(context, map);
  }
}
